import React from 'react';
import Chevron from '../svg/Chevron';

type Props = {
  title: React.ReactNode;
  description: React.ReactNode;
};

const Accordion = ({ title, description }: Props) => {
  return (
    <details className="group relative rounded-28 bg-white-100 after:absolute after:left-0 after:top-0 after:-z-10 after:h-full after:w-full after:rounded-28 after:opacity-0 after:shadow-md after:transition-opacity open:after:opacity-100 hover:after:opacity-100">
      <summary className="[&::-webkit-details-marker]:display-none title-lg flex cursor-pointer list-none items-center justify-between px-32 py-16">
        {title}
        <div className="transition-transform group-open:rotate-180">
          <Chevron />
        </div>
      </summary>
      <div className="pt-5 body-lg px-32 pb-32 text-neutral-10">{description}</div>
    </details>
  );
};

export default Accordion;
